import { getSubdomain } from "../components/shared/StylesheetInjector";
import { NTWTBC } from "../constants/application";

export function isNTWTBC() {
  return getSubdomain() === NTWTBC;
}
